import { render, staticRenderFns } from "./car-model-cmp.vue?vue&type=template&id=0a4046f8"
import script from "./car-model-cmp.vue?vue&type=script&lang=js"
export * from "./car-model-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports